import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('_conceal_items_into_meatball_menu');
	},
};
